export default __webpack_public_path__ + "static/media/campaigns.9ed40737.svg";